<section hidden id="print-section">
  <div class="print-section">
    <header>
      <h3>{{ selectedContract?.customers?.[0]?.name }}</h3>
      <div class="contract-title">
        <p class="contract-title-reference">REFERENCE #</p>
        <p>{{ selectedContract?.reference_code }}</p>
      </div>
    </header>
    <hr class="divider" />
    <div class="product-data">
      <h2>Product Name</h2>
      <p>{{ selectedContract?.products?.[0]?.label }}</p>
    </div>
    <hr class="divider" />
    <div class="cancel-content print-cancel-content">
      <div class="content-row">
        <p class="content-row-title">Cancellation Fee</p>
        <p class="content-row-value">
          {{ cancelQuote?.cancellation_fee | formattedCurrency }}
        </p>
      </div>
      <div class="content-row">
        <p class="content-row-title">Cancellation %</p>
        <p class="content-row-value">{{ cancelQuote?.factors?.cancel }}%</p>
      </div>
      <div class="content-row">
        <p class="content-row-title">Claims Paid</p>
        <p class="content-row-value">
          {{ (cancelQuote?.claims_paid_amount || 0) | formattedCurrency }}
        </p>
      </div>
      <div class="content-row primary-content-row">
        <p class="content-row-title">Final Quote*</p>
        <p class="content-row-value">
          {{ cancelQuote?.cancellation_refund_amount |formattedCurrency }}
        </p>
      </div>
      <div class="content-row">
        <p class="content-row-title">Date of Submission</p>
        <p class="content-row-value">
          {{ cancellationData?.created_at | date: 'MM/dd/yyyy' }}
        </p>
      </div>
      <div class="content-row">
        <p class="content-row-title">Cancellation Date</p>
        <p class="content-row-value">
          {{ cancellationData?.canceled_at | date: 'MM/dd/yyyy' }}
        </p>
      </div>
      <div class="content-row">
        <p class="content-row-title">Cancellation Mileage</p>
        <p class="content-row-value">
          {{ cancellationData?.cancellation_mileage || 0 }}
        </p>
      </div>
    </div>
    <hr />
    <ng-container *ngTemplateOutlet="terms"></ng-container>
  </div>
</section>

<ng-template #terms>
  <div class="terms">
    <div class="section disclaimer">
      <h1>Cancellation Quote Disclaimer</h1>
      <p>
        By proceeding with the cancellation quote, you acknowledge and agree to
        the following:
      </p>
    </div>
    <div class="terms__content">
      <div class="terms__col">
        <div class="section">
          <h2>Real-Time Estimate:</h2>
          <p>
            The quote displayed on your screen is a real-time estimate of the
            cost to cancel at this moment. If you plan to cancel in the future,
            you acknowledge that you cannot rely on the quote displayed at this
            moment. The amount of the quote today may be different from
            tomorrow. To be eligible for the cancellation quote displayed on the
            screen, you need to cancel that day before the cancellation quote
            lapses.
          </p>
        </div>
        <div class="section">
          <h2>Forfeiture of Vehicle Service Contract (“VSC”) Claims:</h2>
          <p>
            Upon making cancellation effective by clicking “final/authorize,”
            you forfeit all rights to any anticipated or pending VSC claims.
          </p>
        </div>
        <div class="section">
          <h2>Voiding of Future Claims:</h2>
          <p>
            Any future claims you may have with the Third-Party Administrator
            (TPA), either under a GAP Agreement or VSC, will be voided at the
            TPA’s discretion upon effective cancellation.
          </p>
        </div>
        <div class="section generation-vs-cancellation">
          <h2>Quote Generation vs. Cancellation Process:</h2>
          <p>
            Customer understands that the generation of a cancellation quote
            does
            <span class="“highlight”">NOT</span> operate as a cancellation.
            Customer acknowledges that cancellation is a separate process.
          </p>
        </div>
        <div class="section">
          <h2>Galaxy 2.0 Process for Cancellation:</h2>
          <ul>
            <li>
              Go to the website, populate your VIN number/contract number in the
              search bar.
            </li>
            <li>Receive a forwarded email to capture your IP address.</li>
            <li>Receive a cancellation quote over email.</li>
            <li>
              If you want to cancel for the quote amount, follow the link in the
              email to effect cancellation.
            </li>
            <li>
              Select the reason for cancellation (optional) and select “run
              quote.“
            </li>
            <li>
              Receive email verification, and once the IP/customer is
              identified, your cancellation quote is generated.
            </li>
            <li>
              Receive confirmation of completed cancellation via email (60 days
              to process).
            </li>
          </ul>
        </div>
      </div>
      <div class="terms__col">
        <div class="section">
          <h2>Cancellation Notice:</h2>
          <p>We want you to be aware that cancellation means the following:</p>
          <ul>
            <li>
              You must have an active contract in force with Dealer Loyalty
              Protection, Inc. (“DLP”) for DLP to generate a cancellation quote.
            </li>
            <li>
              <strong>For VSC cancellations:</strong>
              <ul>
                <li>
                  If you have an open claim under your VSC and cancel the
                  contract, DLP cannot complete the claim. You must verify that
                  you understand your open claim will be denied.
                </li>
              </ul>
            </li>
            <li>
              <strong>For GAP cancellations:</strong>
              <ul>
                <li>
                  If you have an open claim under your GAP agreement, you will
                  be unable to cancel the waiver.
                </li>
                <li>
                  If you experience a total loss, you must either initiate a
                  total loss claim under the GAP agreement, or cancel the policy
                  and waive any claims.
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div class="section important-disclosures">
          <h2>Important Disclosures:</h2>
          <ul>
            <li>
              The contract needs to be active and in-force coverage and/or
              warranties in order to cancel and/or to file a claim.
            </li>
            <li>
              If your cancellation is denied for non-coverage, you will receive
              the notification: “Unable to process your cancellation
              electronically, please contact your selling dealer for further
              assistance.“
            </li>
            <li>
              The quote is just a real-time quote – you understand it does not
              mean your policy is canceled.
            </li>
            <li>
              If you have both a GAP warranty and VSC with DLP, and you
              experience a total loss, canceling the VSC does not affect GAP,
              but you acknowledge that the VSC claim will be denied.
            </li>
          </ul>
        </div>
        <div class="section">
          <h2>Non-Cancelable Products:</h2>
          <p>
            Products and product warranties that are non-cancelable include
            warnings that customers cannot cancel nor do they have recourse for
            refunds under these products.
          </p>
        </div>
      </div>
    </div>
  </div>
</ng-template>
